/**
 * @fileoverview Barrel exports for the plot-synopsis-extractor-v3 agent.
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
} from './schema';

// Flow
export { flow, plotSynopsisExtractorV3AgentFlow } from './flow';

// Prompt template
export { prompt } from './prompt';
